import { EventEntity } from '../schema/EventEntity';
import { EventsCache } from '../schema/EventsCache';
import { logCacheUpdateForDiagnosticsAsync } from 'owa-calendar-cache-diagnostics';

export function replaceEvents<T extends EventEntity>(eventsToAdd: T[], cache: EventsCache<any>) {
    const existingCacheLength = cache.events.length;

    // wipe off the existing events and add new events
    cache.events.splice(0, cache.events.length, ...eventsToAdd);

    // Log to diagnostics panel
    logCacheUpdateForDiagnosticsAsync({
        lockId: '',
        updateMessage: `Replaced ${existingCacheLength} items from cache with ${
            eventsToAdd.length
        } items`,
    });
}
